import React, { useContext, useState } from "react";
import { apis } from "../apis"; // Import the API functions
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom"; // For navigation
import { AuthContext } from "../AuthProvider";
import { Mail, Lock, ArrowRight } from "lucide-react";
import "./Login.css";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  // Validation Schema using Yup
  const validationSchema = Yup.object({
    password: Yup.string().required("كلمة المرور مطلوبة").min(6, "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل"),
  });

  // Formik Form
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setError("");

      try {
        // Call the login API
        const response = await apis.adminLogin(values.email, values.password);

        if (response.status === "success") {
          login(response.token);
          // If login is successful, navigate to the dashboard
          navigate("/dashboard");
        } else {
          setError(response.msg || "بيانات الاعتماد غير صالحة.");
        }
      } catch (err) {
        console.log(err);
        setError("حدث خطأ أثناء تسجيل الدخول.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1 className="auth-title">تسجيل الدخول</h1>

          <form onSubmit={formik.handleSubmit} className="auth-form">
            {/* Email Input */}
            <div className="form-group">
              <label htmlFor="email">البريد الالكتروني</label>
              <div className="input-with-icon">
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="أدخل بريدك الإلكتروني"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className={formik.touched.email && formik.errors.email ? "error" : ""}
                />
              </div>
              {formik.touched.email && formik.errors.email && (
                <div className="error-message">{formik.errors.email}</div>
              )}
            </div>

            {/* Password Input */}
            <div className="form-group">
              <label htmlFor="password">كلمة المرور</label>
              <div className="input-with-icon">
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="أدخل كلمة المرور"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  className={formik.touched.password && formik.errors.password ? "error" : ""}
                />
              </div>
              {formik.touched.password && formik.errors.password && (
                <div className="error-message">{formik.errors.password}</div>
              )}
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? (
                <span className="loading-spinner"></span>
              ) : (
                <>
                  <span>تسجيل الدخول</span>
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>

          <div className="auth-footer">
            <p>
              نسيت كلمة المرور؟{" "}
              <button 
                className="btn-link" 
                onClick={() => navigate("/forgot-password")}
              >
                استعادة كلمة المرور
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
